import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../../common/ajax';
import { config } from '../../../config';
import { ProductListModel } from '../../../models/Product';
import {
  AutocompleteResponseModel,
  SearchResultModel,
} from '../../../models/Search';

interface ISearchProductService {
  getSearchProducts: (
    searchTerm: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ProductListModel[]>>;

  getAutocomplete: (
    searchTerm: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<SearchResultModel[]>>;

  getAutocompleteV2: (
    searchTerm: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<AutocompleteResponseModel>>;

  addRecommendation(
    suggestion: string,
    axiosConfig?: AxiosRequestConfig,
  ): Promise<HttpResponse<void>>;
}

export const searchProductService: ISearchProductService = {
  getSearchProducts(searchTerm, axiosConfig?) {
    return ajax.get<ProductListModel[]>(
      `${config.benefitApiUrl}/search?searchTerm=${searchTerm}`,
      axiosConfig,
    );
  },

  getAutocomplete(searchTerm, axiosConfig?) {
    return ajax.get<SearchResultModel[]>(
      `${config.benefitApiUrl}/search/autocomplete?searchTerm=${searchTerm}`,
      axiosConfig,
    );
  },

  getAutocompleteV2(searchTerm, axiosConfig?) {
    return ajax.get<AutocompleteResponseModel>(
      `${config.benefitApiUrl}/search/autocomplete/v2?searchTerm=${searchTerm}`,
      axiosConfig,
    );
  },

  addRecommendation(
    suggestion: string,
    axiosConfig?: AxiosRequestConfig,
  ): Promise<HttpResponse<void>> {
    return ajax.post(
      `${config.benefitApiUrl}/search/add-search-recommendation`,
      { suggestion },
      axiosConfig,
    );
  },
};
